import Loadable from "react-loadable"
import { Loading } from "@/components/Loading"

export const Prediction = Loadable({
  loader: () => import("./Prediction"),
  loading: Loading
})
